
<template>

  <div class="toggle-outer">
    <div class="tog-spacer"></div>
    <div class="tog-inner">
      <div :class="activeTog == 4 ? 'tog right-tog active-tog' : 'tog right-tog'" @click="$emit('flip', 'spider')">
        <v-popover offset="3" trigger="hover" placement="top">
          <img style="width:20px;height:20px;margin-top:4px;" src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/virus.png" />
          <template slot="popover">
            <hover-component :options="{type: 'mini', text: 'Contagion Risk Profile'}"></hover-component>
          </template>
        </v-popover>
      </div>
      <div :class="activeTog == 1 ? 'tog front-tog active-tog' : 'tog front-tog'" @click="$emit('flip', 'front')">
        <h5>1</h5>
      </div>
      <div :class="activeTog == 2 ? 'tog left-tog active-tog' : 'tog left-tog'" @click="$emit('flip', 'left')">
        <h5>2</h5>
      </div>
      <div :class="activeTog == 3 ? 'tog right-tog active-tog' : 'tog right-tog'" @click="$emit('flip', 'right')">
        <h5>3</h5>
      </div>
    </div>
  </div>

</template>

<script>

import Hover from '../hover/Hover';

export default {

  data(){
    return {
      activeTog: -1
    }
  },

  props: ['curr'],

  components: {
    'hover-component': Hover
  },

  methods: {

    setTogs(){
      return [
        {
          label: '2',
          dir: 'left'
        },
        {
          label: '1',
          dir: 'front'
        },
        {
          label: '3',
          dir: 'right'
        }
      ]
    }

  },

  mounted(){
    this.activeTog = this.curr;
  }

}

</script>

<style>

.toggle-outer {
  width: 212.5px;
  height: 50px;
  position: absolute;
  bottom: 4%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  left: calc(50% - 106.25px);
}

.tog-spacer {
  width: 100%;
  height: 5px;
  background-color: rgb(0, 153, 191);
  position: absolute;
}

.tog-inner {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
}

.tog {
  width: 30px;
  height: 30px;
  border: 3px solid rgb(0, 153, 191);
  background-color: #333237;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.left-tog {
  left: 0px;
}

.front-tog {
  left: 50%;
}

.right-tog {
  left: 100%;
}

.active-tog {
  background-color: rgb(0, 153, 191);
  width: 40px;
  height: 40px;
}

.tog img {
  width: 20px;
  height: 20px;
  transform: rotateZ(180deg);
}

.active-tog img {
  width: 25px;
  height: 25px;
}

</style>



// WEBPACK FOOTER //
// src/components/card/Toggle.vue